var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFiduciarySearchNew = function SvgFiduciarySearchNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 60 60"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1B216B",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.283 26.717 42 35.575a5.26 5.26 0 0 0-1.325-2.2 6.97 6.97 0 0 0-4.867-2.05l-7.016-.075-1.35-1.25a7 7 0 0 0-4.742-1.85h-4.992V25H6.667v2.667H9.8v17.4H6.667v2.666H17.7v-3.15h.733l19.284 6.442 20.708-18.192zm-40.808.95h2.492v17.408h-2.492zm24.633 20.341-18.241-6.091h-1.234v-11.1h5.059c1.091 0 2.133.408 2.933 1.15l2.108 1.941 8.042.092a4.33 4.33 0 0 1 3.008 1.267c.467.466.742 1.083.775 1.775l.075.941h-9.425v2.667h9.634l13.05-10.242 1.8 2.142L37.1 48.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M32.333 8.333a6.667 6.667 0 1 0 0 13.334 6.667 6.667 0 0 0 0-13.334M23 15a9.333 9.333 0 1 1 18.667 0A9.333 9.333 0 0 1 23 15",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m43 28.333-6.667-6.666 1.886-1.886 6.667 6.667z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  })))));
};
export { SvgFiduciarySearchNew as Icon };
export default __webpack_public_path__ + "static/media/fb5bf53a85abb1859afb3ae315985174.svg";